
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// Import application modules.
import { apiClient } from "./injector.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class CommentFormController extends Controller {

	static targets = [
		"authorEmail",
		"comment",
		"commentPreview",
		"submitButton",
	];

	// ---
	// LIFE-CYCLE METHODS.
	// ---

	/**
	* I get called when the controller is bound to the host element.
	*/
	connect() {

		this.previewTimer = null;

	}


	/**
	* I get called when the controller is detached from the host element.
	*/
	disconnect() {

		clearTimeout( this.previewTimer );

	}

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I insert the given emoji (contained within the event) into the comment text.
	*/
	insertEmoji( event ) {

		this.application
			.getControllerForElementAndIdentifier( this.commentTarget, "comment-content" )
			.insertEmoji( event.detail.emoji )
		;
		this.commentTarget.focus();

		this.requestPreview( event );

	}


	/**
	* I request a preview of the current comment markup.
	*/
	requestPreview( event ) {

		// Passing the email through (if it exists) for error log insight.
		var authorEmail = this.hasAuthorEmailTarget
			? this.authorEmailTarget.value
			: ""
		;

		clearTimeout( this.previewTimer );
		this.previewTimer = setTimeout(
			async () => {

				try {

					var response = await apiClient.makeRequest({
						method: "post",
						url: "/blog/comment/preview.htm",
						form: {
							authorEmail: authorEmail,
							content: this.commentTarget.value
						},
						headers: {
							Accept: "text/vnd.fragment-stream.html"
						}
					});

					var previewHtml = response;

				} catch ( error ) {

					if ( ! error.response.headers.get( "Content-Type" ).includes( "vnd.fragment-stream.html" ) ) {

						throw( error );

					}

					var previewHtml = error.data.cause;

				}

				var intermediary = document.createElement( "template" );
				intermediary.innerHTML = previewHtml;

				var streamTemplate = intermediary.content.querySelector( "template" );
				var streamContent = streamTemplate.content.querySelector( ".m-comment-preview" );

				this.commentPreviewTarget.innerHTML = "";
				this.commentPreviewTarget.append( streamContent );

			},
			300
		);

	}


	/**
	* I handle a request to submit the form through an indirect means (such a keystroke).
	*/
	requestSubmit( event ) {

		event.preventDefault();
		this.element.requestSubmit( this.submitButtonTarget );

	}

}
